import { I_ACFFile, I_ACFImage } from '../state/wpDataStore'

// Pick the best URL you care about (prefer a specific size if available)
export function getImageUrl(
  img?: I_ACFImage,
  preferredSize?: string
): string | undefined {
  if (!img) return undefined
  if (preferredSize && typeof img.sizes?.[preferredSize] === 'string') {
    return img.sizes[preferredSize] as string
  }
  return img.url
}

// Build a srcSet from ACF's sizes map (optional)
export function getImageSrcSet(
  img?: I_ACFImage,
  candidates: string[] = ['medium', 'medium_large', 'large']
): string | undefined {
  if (!img?.sizes) return undefined
  const parts: string[] = []
  for (const key of candidates) {
    const url = img.sizes[key]
    const w = img.sizes[`${key}-width`]
    if (typeof url === 'string' && typeof w === 'number') {
      parts.push(`${url} ${w}w`)
    }
  }
  return parts.length ? parts.join(', ') : undefined
}

export function getFileUrl(file?: I_ACFFile): string | undefined {
  return file?.url ?? file?.link
}
